import React, { useState } from "react";
import { auth, db } from "../../firebaseConfig";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { setDoc, doc, Timestamp, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

// Create an instance of GoogleAuthProvider
const googleProvider = new GoogleAuthProvider();

const Register = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const { name, email, password, confirmPassword, error, loading } = values;

  // Handle text changes in inputs
  const handleChange = (e) =>
    setValues({ ...values, [e.target.name]: e.target.value });

  // Classic email/password register
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!name || !email || !password || !confirmPassword) {
      setValues({ ...values, error: "All fields are required" });
      return;
    }
    if (password !== confirmPassword) {
      setValues({ ...values, error: "Password must match" });
      return;
    }

    setValues({ ...values, error: "", loading: true });

    try {
      // Create account
      const result = await createUserWithEmailAndPassword(auth, email, password);

      // Save user in Firestore
      await setDoc(doc(db, "users", result.user.uid), {
        uid: result.user.uid,
        name,
        email,
        createdAt: Timestamp.fromDate(new Date()),
        isOnline: true,
      });

      // Reset form
      setValues({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        error: "",
        loading: false,
      });

      // Redirect
      navigate("/", { replace: true });
    } catch (error) {
      setValues({ ...values, error: error.message, loading: false });
    }
  };

  // Google registration (or sign-in). 
  // If the user doc doesn't exist, create one. Otherwise, update 'isOnline'.
  const handleGoogleRegister = async () => {
    setValues({ ...values, error: "", loading: true });

    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        // New user doc
        await setDoc(userRef, {
          uid: user.uid,
          name: user.displayName || "No Name",
          email: user.email,
          photoUrl: user.photoURL || "",
          photoPath: "",
          createdAt: Timestamp.fromDate(new Date()),
          isOnline: true,
        });
      } else {
        // If user doc already exists, just set isOnline
        await updateDoc(userRef, {
          isOnline: true,
        });
      }

      setValues({ ...values, loading: false });

      // Redirect
      navigate("/", { replace: true });
    } catch (err) {
      setValues({ ...values, error: err.message, loading: false });
    }
  };

  return (
    <form className="shadow rounded p-3 mt-5 form" onSubmit={handleSubmit}>
      <h3 className="text-center mb-3">Create An Account</h3>

      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          Name
        </label>
        <input
          type="text"
          className="form-control"
          name="name"
          value={name}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="email" className="form-label">
          Email
        </label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={email}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">
          Password
        </label>
        <input
          type="password"
          className="form-control"
          name="password"
          value={password}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="confirmPassword" className="form-label">
          Confirm Password
        </label>
        <input
          type="password"
          className="form-control"
          name="confirmPassword"
          value={confirmPassword}
          onChange={handleChange}
        />
      </div>

      {error ? <p className="text-center text-danger">{error}</p> : null}

      {/* Button for email/password register */}
      <div className="text-center mb-3">
        <button className="btn btn-secondary btn-sm" disabled={loading}>
          Register
        </button>
      </div>

      {/* Google register button */}
      <div className="text-center mb-3">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={handleGoogleRegister}
          disabled={loading}
        >
          Sign up with Google
        </button>
      </div>
    </form>
  );
};

export default Register;
